import { useQuery } from "@tanstack/react-query"
import { UseFormReturn } from "react-hook-form"
import { DocListFilter } from "../../types/product"
import shopCore from "../../core/shop.core"

export default function useListWarrantyClaim(methods: UseFormReturn<DocListFilter, any>) {

  const result = useQuery({
    queryKey: ["sales-location"],
    queryFn: async (context) => {
      const result = await shopCore.listWarrantyClaim(context.queryKey)
      return result.data
    }
  })


  return {
    methods,
    ...result
  }
}
